#include <fog_vertex>
// vec4 red = vec4(129./255.,28./255.,9./255.,1.);
// vec4 yellow = vec4(250./255.,255./255.,30./255.,1.0);
// vec4 middleColor = vec4(1, 0.12, 0.04, 1); // blue
// vec4 red = vec4(0,129./255.,9./255.,1.);
// vec4 yellow = vec4(0.,255./255.,30./255.,1.0);
vec4 middleColor = vec4(0.2, 0.75, 0.57, 1);
// red.xyz = pow(red.xyz, vec3(1.0 / 2.2));
// yellow.xyz = pow(yellow.xyz, vec3(1.0 / 2.2));
// vec4 firstColor = gl_FragColor;
// float h = 0.8;
// float mixValue = displacement * 0.6;
// vec4 col = mix(mix(firstColor, red, mixValue/h), mix(red, yellow, (mixValue - h)/(1.0 - h)), step(h, mixValue));
// col.xyz = pow(col.xyz, vec3(1.0 / 2.2));
// gl_FragColor = mix(gl_FragColor, col, displacement * 2.);
float clmp_displacement = clamp(displacement, 0., 1.2);
gl_FragColor = gl_FragColor + middleColor * clmp_displacement * 2.;
gl_FragColor.a = displacement * 2.;
gl_FragColor.a = gl_FragColor.a * 0.1;
// gl_FragColor = vec4( displacement, displacement, displacement, 1. );
// gl_FragColor = vec4( vPos , 1. );